<template>
  <div class="card-body px-0 pt-0 pb-2 vh-50">
    <div class="container py-4">
      <form
        class="w-100 px-md-5"
        method="POST"
        v-on:submit.prevent="submitFormClienteDetalle"
        id="form-cliente-detalle"
      >
        <div class="row">
          <div class="form-group col-md-4">
            <label>Actividad*</label>
            <input
              type="text"
              class="form-control"
              name="actividad"
              v-model="actividad"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label>Domicilio*</label>
            <input
              type="text"
              class="form-control"
              name="domicilio"
              v-model="domicilio"
              required
            />
          </div>
          <div class="form-group col-md-2">
            <label>No. Póliza</label>
            <input
              type="text"
              class="form-control"
              name="poliza"
              v-model="poliza"
              placeholder="Opcional"
            />
          </div>
          <div class="form-group col-md-3">
            <label>Fecha*</label>
            <input
              type="date"
              class="form-control"
              name="fecha"
              v-model="fecha"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label>Notario*</label>
            <input
              type="tel"
              class="form-control"
              name="notario"
              v-model="notario"
              required
            />
          </div>
          <div class="form-group col-md-2">
            <label>No. notaría*</label>
            <input
              type="tel"
              class="form-control"
              name="notaria"
              v-model="notaria"
              required
            />
          </div>
          <div class="form-group col-md-3">
            <label>Inscripción registro</label>
            <input
              type="text"
              class="form-control"
              name="inscripcion"
              v-model="inscripcion"
              placeholder="Opcional"
            />
          </div>
          <div class="text-center mt-1">
            <button
              v-if="modo == 'crear'"
              type="submit"
              class="btn btn-primary me-2 btn-sm"
              :disabled="isLoadingSubmit"
            >
              <span
                v-if="isLoadingSubmit"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Registrar
            </button>
            <button
              v-else-if="modo == 'editar'"
              type="submit"
              class="btn btn-primary me-2 btn-sm"
              :disabled="isLoadingSubmit"
            >
              <span
                v-if="isLoadingSubmit"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Modificar
            </button>
            <router-link
              :to="{ name: 'clientes' }"
              class="btn btn-danger text-white btn-sm"
              >Cancelar</router-link
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";

export default {
  name: "form-cliente-adicional",
  data() {
    return {
      isLoadingSubmit: false,
      actividad: this.clienteDetalle.actividad,
      domicilio: this.clienteDetalle.domicilio,
      poliza: this.clienteDetalle.poliza,
      fecha: this.clienteDetalle.fecha,
      notario: this.clienteDetalle.notario,
      notaria: this.clienteDetalle.no_notaria,
      inscripcion: this.clienteDetalle.inscripcion,
    };
  },
  props: {
    clienteDetalle: {
      type: Object,
      required: false,
      default: () => ({
        actividad: "",
        domicilio: "",
        poliza: "",
        fecha: "",
        notario: "",
        notaria: "",
        inscripcion: "",
      }),
    },
    cliente: {
      type: Object,
      required: true,
    },
    modo: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submitFormClienteDetalle() {
      this.isLoadingSubmit = true;
      const form = document.getElementById("form-cliente-detalle");
      const formData = new FormData(form);

      if (this.modo == "crear") {
        await this.storeClienteDetalle(formData);
      } else if (this.modo == "editar") {
        await this.updateClienteDetalle(formData);
      }
    },
    async storeClienteDetalle(formData) {
      formData.append("cliente_id", this.cliente.id);
      try {
        const response = await appApi().post("clientes/detalle/store", formData);
        const { status, message } = response.data;

        this.isLoadingSubmit = false;

        if (!status) {
          showToast(message, "error");
          return;
        }

        showToast(message, "success");
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },
    async updateClienteDetalle(formData) {
      formData.append("_method", "PUT");
      try {
        const response = await appApi().post(
          `clientes/detalle/update/${this.clienteDetalle.id}`,
          formData
        );
        const { status, message } = response.data;

        this.isLoadingSubmit = false;

        if (!status) {
          showToast(message, "error");
          return;
        }

        showToast(message, "success");
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },
  },
};
</script>

<style></style>
